interface CalendarIconProps {
  className?: string;
}

/**
 * Calendar icon - 24-viewBox, 1.5px stroke, currentColor.
 * Used as the trigger icon for CalendarPopoverButton.
 */
export function CalendarIcon({ className }: CalendarIconProps) {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );
}
